export function setUser(state, payload) {
  state.user = payload;
}

export function updateEmailAddress(state, payload) {
  state.user = state.user.updateEmailAddress(payload);
}

export function clearUser(state) {
  state.user = undefined;
}

export function setShouldUserVerifyEmail(state, payload) {
  state.user.shouldVerifyEmailAddress = payload;
}

export function setPermissions(state, payload) {
  state.permissions = payload;
}

export function clearPermissions(state) {
  state.permissions = [];
}

export function setLabel(state, payload) {
  state.label = payload;
}

export function clearLabel(state) {
  state.label = undefined;
}
